import React from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { Button, Link as ChakraLink, IconButton, Box, } from '@chakra-ui/react';
import { FiExternalLink } from 'react-icons/fi';
export const RouteLink = ({ to, as = to, children, ...props }) => {
    return (<NextLink href={to} passHref as={as}>
      <ChakraLink {...props}>{children}</ChakraLink>
    </NextLink>);
};
export const OutgoingLink = ({ children, isExternal = true, showExternalIcon = false, noreferrer = true, noopener = true, rel = '', ...props }) => {
    const _rel = [
        ...rel.split(' '),
        noopener && 'noopener',
        noreferrer && 'noreferrer',
    ]
        .filter(Boolean)
        .join(' ');
    return (<ChakraLink isExternal={isExternal} rel={_rel} {...props}>
      {children}
      {showExternalIcon && (<Box as={FiExternalLink} display="inline-block" mx="0.2em" mt="-0.25em" fontSize="0.8em" aria-label="(external link)"/>)}
    </ChakraLink>);
};
export const ButtonRouteLink = ({ to, children, ...props }) => (<NextLink href={to} passHref>
    <Button as="a" {...props}>
      {children}
    </Button>
  </NextLink>);
export const IconButtonRouteLink = ({ ...props }) => {
    return <IconButton as={RouteLink} {...props}/>;
};
export const IconButtonOutgoingLink = ({ ...props }) => {
    return <IconButton as={OutgoingLink} {...props}/>;
};
export const navLinkMatch = {
    exact: ({ as, router }) => router?.asPath === as,
    startsWith: ({ as, router }) => router?.asPath?.startsWith(as) || false,
};
export const NavLink = ({ active: activeProps = {
    textDecoration: 'underline',
}, shouldBeActive = navLinkMatch.startsWith, to, as = to, ...props }) => {
    const router = useRouter();
    const active = shouldBeActive({ to, as, router });
    return (<RouteLink {...(active ? activeProps : {})} as={as} to={to} aria-current={active ? 'page' : undefined} {...props}/>);
};
